import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const ThinArrowCircle: VFC<SVGAttributes<SVGElement>> = (props) => {
  // const id = useMemo(() => Math.random().toString(), []);

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* <rect x=".5" y="1.123" width="47" height="47" rx="23.5" fill="#fff" /> */}
      <path d="m27.5 33.623-9-9 9-9" stroke="#535251" strokeWidth="1.5" />
      <rect x=".5" y="1.123" width="46" height="46" rx="23.5" stroke="#535251" />
    </svg>
  );
};

export { ThinArrowCircle };
